let questionIndex = 0;
const nextButtons = Array.from(document.querySelectorAll("button.next"));
const prevButtons = Array.from(document.querySelectorAll("button.previous"));
const quizForm = document.querySelector("#archetypeQuiz");
const quizSubmitButton = quizForm.querySelector('button[type="submit"]');
const quizQuestions = Array.from(document.querySelectorAll(".formQuestionCtn"));
const calculating = document.querySelector("#calculating");
const questionsCtn = document.querySelector(".nutrientCalcQuestionsCtn");
const resultsForm = document.querySelector(".nutrientCalcCtn");
const formInputs = Array.from(quizForm.querySelectorAll("input.formCellInput"));
const selects = Array.from(quizForm.querySelectorAll("select"));
const formRadioContainers = Array.from(
  document.querySelectorAll(".radioCellCtn")
);
// Results elements
const archetypeResultsCtn = document.querySelector(".archetypeCtn");
const archetypeResultsHeader = document.querySelector(".finalResult");
const archetypeResultsDisc = document.querySelector(".finalResultDisc");
const strengthsDisc = document.querySelector(".strengths");
const weaknessesDisc = document.querySelector(".weaknesses");
const bestMatchDisc = document.querySelector(".bestMatchup");
const worstMatchDisc = document.querySelector(".worstMatchup");

const attributes = document.querySelector('.attributesCtn')

// ~~~~
const results = {
  avg: 0,
  rounded: 0,
  title: "None",
  values: {},
};

quizForm.addEventListener("submit", (e) => {
  e.preventDefault();
});

quizSubmitButton.addEventListener("click", (e) => {
  e.preventDefault();

  const lastQuestionCtn = quizSubmitButton.parentElement.parentElement.querySelector('.formCell');
  if (quizSubmitButton.classList.contains("radio")) {
      if (!checkCheckboxes(quizSubmitButton)) {
        return;
      }
    } else {
      if (!checkInput(questionIndex)) {
        return
      }
    }

  // Fade the cards away (or perform any other animations)
  toggleQuestions(-1);

  // Start the dot animation
  startDotAnimation();

  results.values = {
    name: document.querySelector("#name").value,
    height: 72,
    age: 21,
  };

  returnArchetype();

  renderResults();
});

let int;

function startDotAnimation() {
  const span = document.getElementById("calculating");
  span.classList.add("active");
  let dotCount = 0;

  int = setInterval(() => {
    // Increase the dot count (cycles 1-3)
    dotCount = (dotCount % 3) + 1;
    // Update the span text with the base message and repeating dots
    span.textContent = "Calculating your results" + ".".repeat(dotCount);
  }, 500); // Adjust interval time as needed
}

function stopAnimation() {
  const span = document.getElementById("calculating");
  const container = document.querySelector(".archetypeCtn");

  span.classList.remove("active");
  clearInterval(int);
  setTimeout(() => {
    container.style.display = "block";
    questionsCtn.style.display = "none";
  }, 500);
}

// Progress Buttons
nextButtons.forEach((button, bIndex) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();
    if (button.classList.contains("radio")) {
      if (checkCheckboxes(button)) {
        questionIndex++;
        toggleQuestions(questionIndex);
      }
    } else {
      if (checkInput(questionIndex)) {
        questionIndex++;
        toggleQuestions(questionIndex);
      }
    }
  });
});
prevButtons.forEach((button, bIndex) => {
  button.addEventListener("click", (e) => {
    e.preventDefault();

    questionIndex--;
    toggleQuestions(questionIndex);
  });
});

// Input listeners
formInputs.forEach((input, iIndex) => {
  input.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });
});

selects.forEach((input, iIndex) => {
  input.addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  });
});

function returnAverageAnswer() {
  let total = 0;
  const questionsNum = formRadioContainers.length;
  formRadioContainers.forEach((ctn, cIndex) => {
    total += parseInt(ctn.querySelector("input:checked").value);
  });
  total /= questionsNum;
  total = total.toFixed(2);
  return parseFloat(total);
}

function returnArchetype() {
  results.avg = returnAverageAnswer();
  results.rounded = parseInt(results.avg.toFixed(0));
  switch (results.rounded) {
    case 1:
      results.title = "Assassin";
      break;
    case 2:
      results.title = "Tactician";
      break;
    case 3:
      results.title = "Hybrid";
      break;
    case 4:
      results.title = "Brawler";
      break;
    case 5:
      results.title = "Wrestler";
      break;
  }
}

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));


async function renderResults() {
  const header = document.querySelector(".archetypeHeader");
  const headerSvgCtn = document.querySelector(".archetypeLogoCtn");
  const headerSvg = headerSvgCtn.children[0];
  const headerSpan = headerSvgCtn.children[1];
  const archetypeSlider = document.querySelector(".archetypeSlider");
  const archetypeBarCell = document.querySelector(".archetypeUser");

  header.innerHTML = results.values.name + ", your results are in...";
  if(results.title == "Assassin"){
  archetypeResultsHeader.innerHTML = `You are an <span>${results.title}</span>`
    
  } else {
  archetypeResultsHeader.innerHTML = `You are a <span>${results.title}</span>`
    
  }
  switch (results.title) {
    case "Assassin":
      headerSvg.innerHTML = assassinSvg;
      archetypeResultsDisc.innerHTML = asssassinDisc;
      renderList(asssassinStrengths, true, strengthsDisc)
      renderList(asssassinWeaknessess, false, weaknessesDisc)
      bestMatchDisc.innerHTML = assassinBestMatch
      worstMatchDisc.innerHTML = assassinWorstMatch

      attributes.innerHTML = assassinA;
      break;
    case "Tactician":
      headerSvg.innerHTML = tacticianSvg;
      archetypeResultsDisc.innerHTML = tacticianDisc;
      renderList(tacticianStrengths, true, strengthsDisc)
      renderList(tacticianWeaknessess, false, weaknessesDisc)
      bestMatchDisc.innerHTML = tacticianBestMatch
      worstMatchDisc.innerHTML = tacticianWorstMatch

      attributes.innerHTML = tactA;
      
      break;
    case "Hybrid":
      headerSvg.innerHTML = hybridSvg;
      archetypeResultsDisc.innerHTML = hybridDisc;
      renderList(hybridStrengths, true, strengthsDisc)
      renderList(hybridWeaknessess, false, weaknessesDisc)
      bestMatchDisc.innerHTML = hybridBestMatch
      worstMatchDisc.innerHTML = hybridWorstMatch

      attributes.innerHTML = hybridA;
      
      break;
    case "Brawler":
      headerSvg.innerHTML = brawlerSvg;
      archetypeResultsDisc.innerHTML = brawlerDisc;
      renderList(brawlerStrengths, true, strengthsDisc)
      renderList(brawlerWeaknessess, false, weaknessesDisc)
      bestMatchDisc.innerHTML = brawlerBestMatch
      worstMatchDisc.innerHTML = brawlerWorstMatch

      attributes.innerHTML = brawlerA;
      
      break;
    case "Wrestler":
      headerSvg.innerHTML = wrestlerSvg;
      archetypeResultsDisc.innerHTML = wrestlerDisc;
      renderList(wrestlerStrengths, true, strengthsDisc)
      renderList(wrestlerWeaknessess, false, weaknessesDisc)
      bestMatchDisc.innerHTML = wrestlerBestMatch
      worstMatchDisc.innerHTML = wrestlerWorstMatch

      attributes.innerHTML = wrestlerA;
      
      break;
  }
  headerSpan.innerHTML = results.title;

  await delay(1000);
  stopAnimation();

  // Instead of two separate 500ms delays, you could combine them if desired.
  await delay(500);
  await delay(500);
  transformUp(header);

  await delay(800);
  transformUp(headerSvg);

  await delay(200);
  transformUp(headerSpan);

  await delay(400);
  transformUp(archetypeSlider);
  

  await delay(500);
  const percentage = ((results.avg - 1) / 4) * 100;
  archetypeBarCell.style.left = `calc(${percentage}% - ${(results.rounded - 1) * 2}px)`;
  
  transformAllTextCtns()
}

function transformAllTextCtns(){
  const allTextCtns = Array.from(document.querySelectorAll('.archetypeTextCtn'));

  allTextCtns.forEach((ctn, cIndex) => {
    ctn.style.transition = `all .5s var(--cEaseInOut) ${cIndex * .1}s`
    ctn.style.opacity = 1;
    ctn.style.transform = "translateY(0)"
  })
}

function renderList(arr, green = true, element){
  const list = document.createElement('ul');
  if(green){
    list.classList.add('green') 
  } else {
    
    list.classList.add('red') 
  }

  arr.forEach((listItem, lIndex) => {
    const li = document.createElement('li')
    li.innerHTML = listItem
    list.appendChild(li);
  });
  element.appendChild(list)
}

function transformUp(element) {
  element.style.opacity = 1;
  element.style.transform = "translateY(0)";
}

function checkInput(index) {
  
  const input = formInputs[index];
  if (!input.checkValidity()) {
    input.reportValidity(); // This will show the required warning if the input is empty.
    return false;
  } else {
    return true;
  }
}

function checkCheckboxes(button) {
  const inputs = Array.from(
    button.parentElement.parentElement.querySelectorAll("input")
  );
  let checked = 0;
  inputs.forEach((input) => {
    if (input.checked) {
      checked++;
    }
  });
  if (checked > 0) {
    return true;
  } else {
    return false;
  }
}

function toggleQuestions(index) {
  window.scrollTo(0, 0);

  quizQuestions.forEach((question, qIndex) => {
    if (qIndex == index) {
      question.classList.add("active");
    } else {
      question.classList.remove("active");
    }
  });
}



// Results Values

const asssassinDisc = "You may not be the first to shoot for a takedown, but once the fight hits the ground, you become a nightmare. Your mastery of submissions, sweeps, and positional control makes you a dangerous opponent who thrives in the guard and on the bottom. Your ability to set up the position you want is unlike any other archetype. An Assassin knows where they want to go, and have many avenues to get there. They will pick you apart and set traps without you suspecting a thing. One minute you’re passing their guard, the next you’re in a deep triangle."
const asssassinStrengths = [
  "Submissions",
  "Sweeps",
  "Guard passes",
  "Energy conservation / Pacing",
  "Fluidity",
]
const asssassinWeaknessess = [
  "Takedown offense",
  "Takedown defense",
  "Conditioning",
  "Limited pressure game",
  "Relies on the ground",
]
const assassinBestMatch = "Brawler"
const assassinWorstMatch = "Tactician"


const tacticianDisc = "You’re intelligent on the mat, always thinking ahead. Instead of just relying on strength or one style, you focus on your opponent's weaknesses and use your techniques to take advantage of them. Every move you make is part of a bigger plan, carefully timed to put you in the best position to win. Where the Assassin has typically one goal in mind, you have several avenues to pursue. All of which you are excellent at. When on bottom, not only are you a threat to the submission, but you are equally a threat to the sweep. You create dilemmas everywhere on the ground, making it very hard for a wrestler or brawler archetype to succeed."
const tacticianStrengths = [
  "Sweeps",
  "Strategy",
  "Efficient use of energy",
  "Control",
  "Pacing",
]
const tacticianWeaknessess = [
  "Takedown offense",
  "Takedown defense",
  "Lack of overwhelming strength",
  "Overthinking",
  "Vulnerable to aggression",
]
const tacticianBestMatch = "Wrestler or Brawler"
const tacticianWorstMatch = "Hybrid"



const hybridDisc = "Hybrids are special in that they can seamlessly combine the best of all worlds, blending elements of wrestling, submissions, and fluid guard play. You’re adaptable, always ready to adjust your game to the flow of the match, and can thrive in any situation, whether scrambling, sweeping, or attacking submissions. You’re able to defend against superior takedown ability and also superior guard play all at once. You have the most avenues to victory of any archetype."
const hybridStrengths = [
  "Versatile",
  "Pressure",
  "Control",
  "Strategy",
  "Conditioning",

]
const hybridWeaknessess = [
  "Jack of all trades, master of none",
  "Highly aggressive opponents",
  "Opponents with a small mastered skillset",

]
const hybridBestMatch = "Wrestler or Assassin"
const hybridWorstMatch = "Brawler"



const brawlerDisc = "You’re a relentless force on the mat, you thrive in scrambles, impose your will with pressure, and never shy away from a fight. Your game is built on toughness, aggression, and an unbreakable mindset. You thrive in battle more than anyone. In a close 2-2 match, you are the archetype to bet on. Though you have great takedowns and defense, your aggression and pursuit can be a double-edged sword at times, putting you at risk of sweep or submission."
const brawlerStrengths = [
  "Pressure",
  "Control",
  "Toughness",
  "Takedown offense",
  "Scrambles",

]
const brawlerWeaknessess = [
  "Submission defense",
  "Guard passing",
  "Conditioning",
  "Opponents with a small mastered skillset",

]
const brawlerBestMatch = "Hybrid"
const brawlerWorstMatch = "Assassin"



const wrestlerDisc = "You dominate the mat with precision, speed, and control. Your game revolves around explosive takedowns, strong grips, and a relentless pursuit of position. Once you establish control, it's near impossible for anyone to escape. Not only can Wrestlers get control of their opponent, they are exceptional at maintaining it as well. Their weight control is best in class. When you’re going against a wrestler, it feels like you have someone 2 times the weight limit attacking you."
const wrestlerStrengths = [
  "Takedowns",
  "Pressure",
  "Physical Strength",
  "Control",
  "Conditioning",
  "Toughness",

]
const wrestlerWeaknessess = [
  "Submission offense",
  "Submission defense",
  "Guard passing",
  "Ground game",

]
const wrestlerBestMatch = "Brawler"
const wrestlerWorstMatch = "Tactician"


